<template>
  <alert-box type="danger" v-if="hasErrors" class="validation-alert-box">
    <icon name="bolt" />
    <strong>
      {{$t('validationAlertBox.title')}}
    </strong>
    <ul class="validation-alert-box__errors">
      <li class="validation-alert-box__error" v-for="error in errors">
        {{error}}
      </li>
    </ul>
  </alert-box>
</template>

<script>
import Validation from '@/mixins/Validation';

export default {
  name: 'validation-alert-box',
  mixins: [Validation],
  i18n: {
    messages: {
      de: {
        validationAlertBox: {
          title: 'Achtung!',
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.validation-alert-box__errors {
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: inline-block;
}

.validation-alert-box__error {
  display: inline-block;

  &:before {
    content: ", ";
  }

  &:first-child:before {
    content: "";
  }
}
</style>



// WEBPACK FOOTER //
// ValidationAlertBox.vue?760d31fe